import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useLang } from "../i18n/LangContext";

export const Testimonials = () => {
  const { t } = useLang();
  const items = t("testimonials.items");

  return (
    <section
      data-testid="section-testimonials"
      className="relative py-24 lg:py-32 bg-black"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-primary-red" />
            <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-zinc-400">
              {t("testimonials.eyebrow")}
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.05] tracking-tight">
            {t("testimonials.title")}
          </h2>
          <p className="mt-4 text-xs uppercase tracking-widest text-gold">
            {t("testimonials.placeholder")}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 lg:gap-5">
          {items.map((it, i) => (
            <motion.figure
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.08 * i }}
              className="relative bg-[#0a0a0a] border border-white/10 p-8 lg:p-10 hover:border-white/25 transition-colors"
            >
              <Quote size={28} className="text-primary-red mb-6" />
              <blockquote className="font-body text-base lg:text-lg text-zinc-200 leading-relaxed">
                &ldquo;{it.q}&rdquo;
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/10 flex flex-col items-center gap-3 text-center">
                <span className="text-xs uppercase tracking-[0.2em] text-zinc-500">
                  {it.n}
                </span>
                <span className="flex items-center gap-1.5">
                  {[...Array(5)].map((_, k) => (
                    <Star key={k} size={18} className="text-gold fill-current" />
                  ))}
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
